var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"spine",attrs:{"src":this.img,"alt":"spine"}})
}
var staticRenderFns = []

export { render, staticRenderFns }